module.exports = __webpack_public_path__ + "img/tg.c666617d.png";